/*
 * 渠道id
 * 1:微信公众号
 * 2:微信小程序
 * 3:官网h5
 * 4:小程序插件
 * 5:app
 * 6:企业微信
 * 7:小程序应用
 */
export const TYPE_ID = {
  WX_OFFICIAL_ACCOUNT: 1,
  WX_MINA: 2,
  H5: 3,
  MINA_PLUGIN: 4,
  APP: 5,
  WX_WORK: 6,
  MINI_PROGRAM: 7,
}

/*
 * 消息来源
 * 1:客户消息
 * 2:客服消息
 * 3:客户系统消息
 * 4:系统消息
 * 5:机器人消息
 */
export const SEND_FROM = {
  CUSTOMER: 1,
  CUSTOMER_SERVICE: 2,
  CUSTOMER_SYSTEM: 3,
  SYSTEM: 4,
  ROBOT: 5,
}
/*
 * 服务类型
 * 1:服务店
 * 2:充电桩服务商
 * 3:OTA召回
 * 4:OTA升级
 * 5:历史工单
 * 6:车主认证
 * 7:购车订单
 */
export const SPECIAL_MSG_TYPE = {
  SERVICE_SHOP: 1,
  CHARGING_STATION: 2,
  OTA_RECALL: 3,
  OTA_UPGRADE: 4,
  HISTORY_WORK_ORDER: 5,
  CAR_OWNER_AUTH: 6,
  CAR_PURCHASE_ORDER: 7,
}
export const DEFAULT_EMPTY='--'
